
import {
  Box,
  Button,
  Flex,
  FormLabel,
  Select,
  SimpleGrid,
  Icon,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useColorModeValue,
  useTheme,
  FormControl,
  FormErrorMessage,
  Input,
  IconButton,
} from '@chakra-ui/react';


// Custom components
import Card from 'components/card/Card';
import InputField from 'components/fields/InputField';
import TextField from 'components/fields/TextField';
import TagsField from 'components/fields/TagsField';
import Dropzone from 'views/admin/main/ecommerce/newProduct/components/Dropzone';
import React, { useEffect, useRef, useState } from 'react';

// Assets
import { MdOutlineCloudUpload, MdPhoto } from 'react-icons/md';
import { useForm } from 'react-hook-form'

//INICIA SESION
import { useJwt } from "react-jwt";
import { getCookie } from 'cookies-next';

export default function NewProduct() {
  const token = getCookie('token')
  const jwt = useJwt(token);

  //OBTIENE SESION

  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const [textFileEvidencia, settextFileEvidencia] = useState('')

  const [activeBullets, setActiveBullets] = useState({
    product: true,
    media: false,
    pricing: false,
  });
  const [file, setFile] = useState()
  const [Empresa, setEmpresa] = useState('')
  const [Categoria, setCategoria] = useState('')
  const onBtnClickevi = () => {
    /*Collecting node-element and performing click*/
    inputFileRefevi.current.click();
  }
  const inputFileRefevi = useRef(null);

  function handleChangeEvi(event: any) {
    setFile(event.target.files[0]);
    try {
      if (event.target?.files[0])

        settextFileEvidencia(String(event.target.files[0].name));
    } catch {
      settextFileEvidencia('');
      console.log('Sin nombre')
    }
    console.log(event.target.files[0]);
  }

  function handleChange(event: any) {

    setFile(event.target.files[0])
    console.log(event.target.files[0]);
    console.error('nomms');
  }


  function handleChangeEmpresa(event: any) {
    //alert(event.target.value)
    setEmpresa(event.target.value)
  }

  function handleChangeCategoria(event: any) {
    //alert(event.target.value)

    setCategoria(event.target.value)
  }


  const [message, setMessage] = useState('');


  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm()

  function onSubmit(values: any) {
    return new Promise(async (resolve) => {
      const formData = new FormData();
      //var json = JSON(values, null, 2);
      for (var key in values) {
        console.warn(key)
        let value = values[key];
        formData.append(key, value);
      }
      formData.append('Fotografia', file);
      formData.append('Empresa', Empresa);
      formData.append('Categoria', Categoria);
      formData.append('fileName', 'archivito');
      console.log(formData);
      //alert(process.env.REACT_APP_SECRET_NAME        );


      var valores = JSON.stringify(jwt.decodedToken);
      var valoresx = await JSON.parse(valores);
      alert(valoresx.nombre);

      const response = await fetch(process.env.REACT_APP_URL_SERVER + '/new_provedor',
        //http://127.0.0.1:3000/new_provedor/90/INE
        {
          body: formData,
          method: "post",
          credentials: 'include',
        });
      alert('Proveedor Registrado')
    })
  }

  const productTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const mediaTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const pricingTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const theme = useTheme();
  //eslint-disable-next-line
  const [lineColor, setLineColor] = useState(theme.colors.brand[500]);
  //eslint-disable-next-line
  const [lineColorDark, setLineColorDark] = useState(theme.colors.brand[400]);
  const brand = useColorModeValue(lineColor, lineColorDark);
  //const {register, handleSubmit, formState: {errors}} = useForm();
  const url = process.env.REACT_APP_URL_SERVER + '/empresas';
  const [data1, setData1] = useState([]);
  let genero = [
    { id: "1", valor: "Femenino" },
    { id: "2", valor: "Masculino" },
    { id: "3", valor: "Sin Definir" }
  ]


  const url2 = process.env.REACT_APP_URL_SERVER + '/categorias';
  const [data2, setData2] = useState([]);

  useEffect(() => {
    //
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(url, { credentials: 'include' });
      const result = await response.json();

      console.warn(result)
      setData1(result);
      const response1 = await fetch(url2, { credentials: 'include' });
      const result1 = await response1.json();
      setData2(result1);

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>

      <Flex
        direction="column"
        minH="100vh"
        align="center"
        pt={{ sm: '125px', lg: '75px' }}
        position="relative"
      >
        {/* 
        <Box
          h="45vh"
          bgGradient="linear(to-b, brand.400, brand.600)"
          position="absolute"
          w="100%"
          borderRadius="20px"
        /> */}

        <Tabs
        // variant="unstyled"
        // mt={{ base: '60px', md: '165px' }}
        // zIndex="0"
        // display="flex"
        // flexDirection="column"
        >
          {/* <TabList
            display="flex"
            alignItems="center"
            alignSelf="center"
            justifySelf="center"
          >
            <Tab
              _focus={{ border: '0px', boxShadow: 'unset' }}
              ref={productTab}
              w={{ sm: '120px', md: '250px', lg: '300px' }}
              onClick={() =>
                setActiveBullets({
                  product: true,
                  media: false,
                  pricing: false,
                })
              }
            >
              <Flex
                direction="column"
                justify="center"
                align="center"
                position="relative"
                _before={{
                  content: "''",
                  width: { sm: '120px', md: '250px', lg: '300px' },
                  height: '3px',
                  bg: activeBullets.media ? 'white' : 'brand.400',
                  left: { sm: '12px', md: '40px' },
                  top: {
                    sm: activeBullets.product ? '6px' : '4px',
                    md: null,
                  },
                  position: 'absolute',
                  bottom: activeBullets.product ? '40px' : '38px',

                  transition: 'all .3s ease',
                }}
              >
                <Box
                  zIndex="1"
                  border="2px solid"
                  borderColor={activeBullets.product ? 'white' : 'brand.400'}
                  bgGradient="linear(to-b, brand.400, brand.600)"
                  w="16px"
                  h="16px"
                  mb="8px"
                  borderRadius="50%"
                />
                <Text
                  color={activeBullets.product ? 'white' : 'gray.300'}
                  fontWeight={activeBullets.product ? 'bold' : 'normal'}
                  display={{ sm: 'none', md: 'block' }}
                >
                  Registro de Votante
                </Text>
              </Flex>
            </Tab>
            <Tab
              _focus={{ border: '0px', boxShadow: 'unset' }}
              ref={mediaTab}
              w={{ sm: '120px', md: '250px', lg: '300px' }}
              onClick={() =>
                setActiveBullets({
                  product: true,
                  media: true,
                  pricing: false,
                })
              }
            >
              <Flex
                direction="column"
                justify="center"
                align="center"
                position="relative"
                _before={{
                  content: "''",
                  width: { sm: '120px', md: '250px', lg: '300px' },
                  height: '3px',
                  bg: activeBullets.pricing ? 'white' : 'brand.400',
                  left: { sm: '12px', md: '28px' },
                  top: '6px',
                  position: 'absolute',
                  bottom: activeBullets.media ? '40px' : '38px',

                  transition: 'all .3s ease',
                }}
              >
                <Box
                  zIndex="1"
                  border="2px solid"
                  borderColor={activeBullets.media ? 'white' : 'brand.400'}
                  bgGradient="linear(to-b, brand.400, brand.600)"
                  w="16px"
                  h="16px"
                  mb="8px"
                  borderRadius="50%"
                />
                <Text
                  color={activeBullets.media ? 'white' : 'gray.300'}
                  fontWeight={activeBullets.media ? 'bold' : 'normal'}
                  display={{ sm: 'none', md: 'block' }}
                >
                  Media
                </Text>
              </Flex>
            </Tab>
            <Tab
              _focus={{ border: '0px', boxShadow: 'unset' }}
              ref={pricingTab}
              w={{ sm: '120px', md: '250px', lg: '300px' }}
              onClick={() =>
                setActiveBullets({
                  product: true,
                  media: true,
                  pricing: true,
                })
              }
            >
              <Flex
                direction="column"
                justify="center"
                align="center"
                position="relative"
              >
                <Box
                  zIndex="1"
                  border="2px solid"
                  borderColor={activeBullets.pricing ? 'white' : 'brand.400'}
                  bgGradient="linear(to-b, brand.400, brand.600)"
                  w="16px"
                  h="16px"
                  mb="8px"
                  borderRadius="50%"
                />
                <Text
                  color={activeBullets.pricing ? 'white' : 'gray.300'}
                  fontWeight={activeBullets.pricing ? 'bold' : 'normal'}
                  display={{ sm: 'none', md: 'block' }}
                >
                  Precios y Categoria
                </Text>
              </Flex>
            </Tab>
          </TabList> */}

          <TabPanels mt="24px" maxW={{ md: '90%', lg: '100%' }} mx="auto">
            <TabPanel
              w={{ sm: '330px', md: '700px', lg: '850px' }}
              p="0px"
              mx="auto"
            >
              <Card p="30px">
                <Text color={textColor} fontSize="2xl" fontWeight="700" mb="20px">
                  Datos Generales
                </Text>

                <Flex direction="column" w="100%">
                  <SimpleGrid columns={{ base: 1, md: 2 }} gap="20px">
                    <Stack direction="column" gap="20px">
                      <InputField
                        mb="0px"
                        id="Nombre"
                        name="Nombre"
                        placeholder="Emiliano"
                        label="Nombre"
                        nombre="Nombre"
                        registro={register}
                      />

                      <InputField
                        mb="0px"
                        id="ApellidoPaterno"
                        name="ApellidoPaterno"
                        placeholder="Torres"
                        label="Apellido Paterno"
                        nombre="ApellidoPaterno"
                        registro={register}
                      />


                      <InputField
                        mb="0px"
                        id="ApellidoMaterno"
                        name="ApellidoMaterno"
                        placeholder="Garcia"
                        label="Apellido Materno"
                        nombre="ApellidoMaterno"
                        registro={register}
                      />

                      <InputField
                        mb="0px"
                        id="Telefono"
                        name="Telefono"
                        type='number'
                        placeholder="2411099090"
                        label="Telefono"
                        nombre="Telefono"
                        registro={register}
                      />

                      <InputField
                        mb="0px"
                        id="Email"
                        name="Email"
                        placeholder="tecnoinnova@ti.com"
                        label="Email"
                        type='email'
                        nombre="Email"
                        registro={register}
                      />
                      <InputField
                        mb="0px"
                        id="Ocupacion"
                        name="Ocupacion"
                        placeholder="Programador"
                        label="Ocupacion"
                        nombre="Ocupacion"
                        registro={register}
                      />



                      <InputField
                        mb="0px"
                        id="Calle"
                        name="Calle"
                        placeholder="Centenario Dpto. C99"
                        label="Calle"
                        nombre="Calle"
                        registro={register}
                      />

                      <InputField
                        mb="0px"
                        id="RFC"
                        name="RFC"
                        placeholder="."
                        label="RFC"
                        nombre="RFC"
                        registro={register}
                      />
                      <Flex direction="column" mb="34px">
                        <FormLabel
                          ms="10px"
                          htmlFor="Categoria"
                          fontSize="sm"
                          color={textColor}
                          fontWeight="bold"
                          _hover={{ cursor: 'pointer' }}
                        >
                          Acuse de R.N.P                        </FormLabel>
                        <Input
                          style={{ display: "none" }}
                          ref={inputFileRefevi}
                          accept=".png,.jpg,.jpeg,.pdf"
                          id='filexe'
                          type="file" onChange={handleChangeEvi} />
                        <IconButton onClick={onBtnClickevi} aria-label={''}>
                          <Icon as={MdPhoto} h='34px' w='34px' color='red.300' />
                        </IconButton>
                        <Text> Archivo Seleccionado: {textFileEvidencia}</Text>
                      </Flex>
                    </Stack>
                    <Stack direction="column" gap="20px">

                      <InputField
                        mb="0px"
                        id="RSocial"
                        name="RSocial"
                        placeholder="TECNO INNOVA S.A. de C.V."
                        label="Razon Social"
                        nombre="RSocial"
                        registro={register}
                      />

                      <InputField
                        mb="0px"
                        id="NVivienda"
                        name="NVivienda"
                        placeholder="Edificio K Depto 280"
                        label="Numero de Vivienda"
                        nombre="NVivienda"
                        registro={register}
                      />
                      <InputField
                        mb="0px"
                        id="Colonia"
                        name="Colonia"
                        placeholder="San Martin de Porres"
                        label="Colonia"
                        nombre="Colonia"
                        registro={register}
                      />

                      <InputField
                        mb="0px"
                        id="Referencias"
                        name="Referencias"
                        placeholder="Frente a Seguro Social"
                        label="Referencias"
                        nombre="Referencias"
                        registro={register}
                      />

                      <InputField
                        mb="0px"
                        id="CodigoPostal"
                        name="CodigoPostal"
                        type='number'
                        placeholder="90300"
                        label="Codigo Postal"
                        nombre="CodigoPostal"
                        registro={register}
                      />

                      <InputField
                        mb="0px"
                        id="Nacimiento"
                        name="Nacimiento"
                        type='date'
                        placeholder="12/12/1993"
                        label="Fecha de Nacimiento"
                        nombre="Nacimiento"
                        registro={register}
                      />



                      <Flex direction="column" mb="34px">
                        <FormLabel
                          ms="10px"
                          htmlFor="Genero"
                          fontSize="sm"
                          color={textColor}
                          fontWeight="bold"
                          _hover={{ cursor: 'pointer' }}

                        >
                          Genero
                        </FormLabel>

                        <Select fontSize="sm"
                          id="Genero"
                          variant="main"
                          h="44px"
                          maxH="44px"
                          name="Genero"
                          onChange={handleChangeEmpresa}
                        >
                          <option> </option>
                          {genero.map((e, key) => {
                            return <option key={key} value={e.id}>{e.valor}</option>;
                          })}
                        </Select>
                      </Flex>

                      <InputField
                        mb="0px"
                        id="CURP"
                        name="CURP"
                        placeholder="CAGY931129"
                        label="CURP"
                        nombre="CURP"
                        registro={register}
                      />



                    </Stack>
                  </SimpleGrid>
                  <Flex justify="center" mt="24px">
                    {/*  <Button
                      variant="darkBrand"
                      fontSize="sm"
                      borderRadius="16px"
                      w={{ base: '128px', md: '148px' }}
                      h="46px"
                      ms="auto"
                      onClick={() => mediaTab.current.click()}
                    >
                      Siguiente
                    </Button>
                  </Flex> */}
                    <Button
                      variant="darkBrand"
                      type='submit'
                      fontSize="sm"
                      borderRadius="16px"
                      w={{ base: '128px', md: '148px' }}
                      h="46px"
                    // onClick={handleClick}
                    >
                      Guardar
                    </Button>
                  </Flex>
                </Flex>
              </Card>
            </TabPanel>
            {/* <TabPanel
              w={{ sm: '330px', md: '700px', lg: '850px' }}
              p="0px"
              mx="auto"
            >
              <Card p="30px">
                <Text color={textColor} fontSize="2xl" fontWeight="700" mb="20px">
                  Media
                </Text>
                <Dropzone

                  nombre="Archivo"
                  registro={register}
                  id={'Archivo'}

                  content={
                    <Box onChange={handleChange}>
                      <Icon
                        as={MdOutlineCloudUpload}
                        w="80px"
                        h="80px"
                        color={textColor}
                      />
                      <Text
                        mx="auto"
                        mb="12px"
                        fontSize="lg"
                        fontWeight="700"
                        whiteSpace="pre-wrap"
                        color={textColor}
                      >
                        Arrastra o Selecciona su imagen{' '}
                        <Text
                          as="span"
                          fontSize="lg"
                          fontWeight="700"
                          color={brand}
                        >

                        </Text>
                      </Text>
                      <Text
                        fontSize="sm"
                        fontWeight="500"
                        color="secondaryGray.500"
                      >
                        Solo PNG, JPG y GIF
                      </Text>
                    </Box>
                  }
                />
                <Flex justify="space-between" mt="24px">
                  <Button
                    variant="light"
                    fontSize="sm"
                    borderRadius="16px"
                    w={{ base: '128px', md: '148px' }}
                    h="46px"
                    onClick={() => productTab.current.click()}
                  >
                    Anterior
                  </Button>
                  <Button
                    variant="darkBrand"
                    fontSize="sm"
                    borderRadius="16px"
                    w={{ base: '128px', md: '148px' }}
                    h="46px"
                    onClick={() => pricingTab.current.click()}
                  >
                    Siguiente
                  </Button>
                </Flex>
              </Card>
            </TabPanel> */}
            {/* <TabPanel
              w={{ sm: '330px', md: '700px', lg: '850px' }}
              p="0px"
              mx="auto"
            >
              <Card p="30px">
                <Text color={textColor} fontSize="2xl" fontWeight="700" mb="20px">
                  Precio
                </Text>
                <Flex direction="column" w="100%">
                  <Stack direction="column" spacing="20px">
                    <SimpleGrid
                      columns={{ base: 1, md: 3 }}
                      gap={{ base: '0px', md: '20px' }}
                    >
                      <InputField
                        id="price"
                        placeholder="eg. $250"
                        label="Precio"
                        type='number'
                        nombre="Precio"
                        registro={register}
                      />
                      <InputField
                        id="code"
                        placeholder="eg. 4030120241"
                        label="Codigo de Barras"
                        type='number'
                        nombre="Codigo"
                        registro={register}
                      />

                      <Flex direction="column" mb="34px">
                        <FormLabel
                          ms="10px"
                          htmlFor="Categoria"
                          fontSize="sm"
                          color={textColor}
                          fontWeight="bold"
                          _hover={{ cursor: 'pointer' }}
                        >
                          Imagen
                        </FormLabel>
                        <input
                          type="file" onChange={handleChange} />
                      </Flex>

                      <Flex direction="column" mb="34px">
                        <FormLabel
                          ms="10px"
                          htmlFor="Empresa"
                          fontSize="sm"
                          color={textColor}
                          fontWeight="bold"
                          _hover={{ cursor: 'pointer' }}

                        >
                          Empresa
                        </FormLabel>

                        <Select fontSize="sm"
                          id="currency"
                          variant="main"
                          h="44px"
                          maxH="44px"
                          name="Empresa"
                          onChange={handleChangeEmpresa}
                        >
                          <option> </option>
                          {data1.map((e, key) => {
                            return <option key={key} value={e.id}>{e.NombreEmpresa}</option>;
                          })}
                        </Select>
                      </Flex>

                      <Flex direction="column" mb="34px">
                        <FormLabel
                          ms="10px"
                          htmlFor="Categoria"
                          fontSize="sm"
                          color={textColor}
                          fontWeight="bold"
                          _hover={{ cursor: 'pointer' }}

                        >
                          Categoria
                        </FormLabel>

                        <Select fontSize="sm"
                          id="currency"
                          variant="main"
                          h="44px"
                          maxH="44px"
                          name="Categoria"

                          onChange={handleChangeCategoria}
                        >
                          <option> </option>

                          {data2.map((e, key) => {
                            return <option key={key} value={e.id}>{e.name}</option>;
                          })}
                        </Select>
                      </Flex>
                    </SimpleGrid>
                  </Stack>
                  <Flex justify="space-between" mt="24px">
                    <Button
                      variant="light"
                      fontSize="sm"
                      borderRadius="16px"
                      w={{ base: '128px', md: '148px' }}
                      h="46px"
                      onClick={() => mediaTab.current.click()}
                    >
                      Anterior
                    </Button>
                    <Button
                      variant="darkBrand"
                      type='submit'
                      fontSize="sm"
                      borderRadius="16px"
                      w={{ base: '128px', md: '148px' }}
                      h="46px"
                    // onClick={handleClick}
                    >
                      Guardar
                    </Button>
                  </Flex>
                </Flex>
              </Card>
            </TabPanel> */}
          </TabPanels>
        </Tabs>
      </Flex>
    </form>
  );
}
